import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * When an assignAgentAccess request is made, attempts to execute the API
 * request and send out the appropriate success or error action afterwards
 */
export const assignAgentAccessOnRequest = store.effects.create(
  (feature: Feature) =>
    feature.actions.assignAgentAccess.request.observe().pipe(
      rxjs.mergeMap(action =>
        feature.api.assignAgentAccess(action.data.assignments).pipe(
          rxjs.map(() =>
            feature.actions.assignAgentAccess.success.from(action).create({
              request: action.data,
            }),
          ),
          rxjs.catchError(error =>
            rxjs.of(
              feature.actions.assignAgentAccess.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
